export default __webpack_public_path__ + "static/media/filter_icon.e1575926.svg";